// 存放页面路由
export enum PageEnum {
    HOME = 'Home',
    /**
     * 人机页面
     */
    GAMEROBOT = 'GameRobot',
    /**
     * 对局
     */
    COMPETE = 'GameCompete',
    /**
     * 习题
     */
    SUBJECT = 'SubjectIndex',
    /**
     * 习题支付
     */
    SUBJECT_PAYMENT = 'SubjectPayment',
    /**
     * 固定习题
     */
    STABLE = 'SubjectIndexStable',
    /**
     * 随机习题
     */
    RANDOM = 'SubjectIndexRandom',
    /**
     * 限时冲刺
     */
    SPRINT = 'SubjectIndexSprintExercise',
    /**
     * 好友习题 PK
     */
    SPRINT_FRIEND_PK = 'SubjectIndexSprintFriendPk',
    /**
     * 开局树
     */
    OPEN_TREE = 'SubjectIndexOpenTree',
    /**
     * 开局练习
     */
    OPEN_AI_TRAIN = 'SubjectIndexOpenAiTrain',
    /**
     * 开局练习 - 选择
     */
    OpenAiTrainChoose = 'OpenAiTrainChoose',
    /**
     * 开局练习 - 自定义条件
     */
    OpenAiTrainCustomCondition = 'OpenAiTrainCustomCondition',
    /**
     * 新闻列表
     */
    NEWS = 'News',
    /**
     * 直播列表
     */
    LIVE_INDEX = 'LiveIndex',
    /**
     * 直播详情
     */
    LIVE_DETAIL = 'LiveDetail',
    /**
     * 对局记录
     */
    RECORD_INDEX = 'RecordIndex',
    /**
     * 对局详情
     */
    REVIEW = 'Review',
    /**
     * 失误页面
     */
    MISTAKE = 'Mistake',
    /**
     * 对局详情
     */
    REVIEW_PAYMENT = 'ReviewPayment',
    /**
     * 设置
     */
    SETTING = 'Setting',
    /**
     * 锦标赛
     */
    CHAMPIONSHIPS = 'Championships',
    /**
     * 锦标赛详情
     */
    COMPETITION_DETAILS = 'CompetitionDetails',
    /**
     * 锦标赛对局
     */
    COMPETITION_GAME = 'CompetitionGame',
    /**
     * 战力赛
     */
    ENTERTAINMENTS = 'entertainments',
    /**
     * 战力赛详情
     */
    ENTERTAINMENT_DETAILS = 'EntertainmentDetails',
    /**
     * 战力赛对局
     */
    ENTERTAINMENT_GAME = 'EntertainmentGame',
    /**
     * 网校网赛
     */
    SCHOOL_COMPETITION = 'SchoolCompetition',
    /**
     * 网校网赛详情
     */
    SCHOOL_COMPETITION_DETAILS = 'SchoolCompetitionDetails',
    /**
     * 网校网赛对局
     */
    SCHOOL_COMPETITION_GAME = 'SchoolCompetitionGame',
    /**
     * 个人中心
     */
    USERINFO = 'UserinfoIndex',
    /**
     * 我的勋章
     */
    MEDAL = 'Medal',
    /**
     * 我的收藏
     */
    COLLECTION = 'Collection',
    /**
     * 我的cy
     */
    CY = 'cy',
    /**
     * 购买cy权益
     */
    CY_BUY = 'cyBuy',
    /**
     * 历史评分
     */
    SCORE = 'score',
}
